import {LeadEventApiDto, LeadQuoteStatusChangedEventDataApiDto,} from "../../../api/model/rest";
import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {option, Option} from "ts-option";
import moment = require("moment");

export default class LeadQuoteStatusChangedEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param data lead quote status change data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadQuoteStatusChangedEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadQuoteStatusChangedEvent {
		const data = LeadQuoteStatusChangedEventData.fromJson(json.data as LeadQuoteStatusChangedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadQuoteStatusChangedEvent(json.id,
			json.leadId,
			LeadEventTypeEnum.QuoteStatusChanged,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getActivityAdditionalMessages(): string[] {
		let additionalMessages = this.data.statusComment.map(comment => [comment]).getOrElse([]);
		additionalMessages.push(this.data.jobTypeName);
		return additionalMessages;
	}

	getActivityType(): string {
		return `QUOTE ${this.data.quoteNumber}${this.data.versionNumber > 1 ? ` v${this.data.versionNumber}` : ""}`
	}

	getActivityMessage(): string {
		return `Quote status changed to ${this.data.status}`;
	}
}

export class LeadQuoteStatusChangedEventData {
	constructor(public readonly quoteId: string,
		public readonly quoteNumber: number,
		public readonly status: string,
		public readonly prevStatus: string,
		public readonly statusComment: Option<string>,
		public readonly jobTypeName: string,
		public readonly jobTypeId: string,
		public readonly versionNumber: number) {}

	public static fromJson(json: LeadQuoteStatusChangedEventDataApiDto): LeadQuoteStatusChangedEventData {
		return new LeadQuoteStatusChangedEventData(json.id,
			json.quoteNumber,
			json.status,
			json.prevStatus,
			option(json.statusComment),
			json.jobTypeName,
			json.jobTypeId,
			json.versionNumber);
	}
}
